"use client";

import React from 'react';

const testimonials = [
  {
    quote: "Montaż na posesji w Kutnie zrobili w jeden dzień. Kamery na podjeździe i w ogrodzie dają ostry obraz nawet w nocy. Aplikacja na telefonie jest prosta — widzę wszystko z pracy.",
    name: "Piotr Wiśniewski",
    role: "Właściciel domu",
    location: "Kutno"
  },
  {
    quote: "Mieliśmy problem z kradzieżami na placu. Po instalacji kamer z rozpoznawaniem tablic od razu spadła liczba incydentów. Wycena była uczciwa, bez dopłat na końcu.",
    name: "Agnieszka Król",
    role: "Właścicielka warsztatu",
    location: "Żychlin"
  },
  {
    quote: "System w sklepie spożywczym działa bezawaryjnie od ponad roku. Podgląd na kasach i w magazynie, powiadomienia na telefon. Polecam — lokalna firma, szybki dojazd.",
    name: "Łukasz Szymański",
    role: "Właściciel sklepu",
    location: "Łęczyca"
  },
  {
    quote: "Wspólnota mieszkaniowa szukała kogoś z regionu. DaHaka zrobiła projekt klatek, parkingu i placu zabaw. Mieszkańcy są zadowoleni, a my mamy nagrania gdy trzeba.",
    name: "Ewa Baran",
    role: "Zarządca wspólnoty",
    location: "Krośniewice"
  },
  {
    quote: "Magazyn 2000 m², kamery z zoomem na bramie i noktowizja na ogrodzeniu. Serwis przyjechał następnego dnia, gdy padł zasilacz. Tak powinno wyglądać wsparcie.",
    name: "Dariusz Leśniak",
    role: "Kierownik logistyki",
    location: "Łowicz"
  },
  {
    quote: "Nie wciskali zbędnych kamer. Dobrali obiektywy pod nasz budynek i parking. Podgląd na tablecie w biurze i na telefonie. Czysta robota.",
    name: "Monika Jankowska",
    role: "Właścicielka firmy",
    location: "Gostynin"
  }
];

export default function Testimonials() {
  return (
    <section id="opinie" className="section-band border-y">
      <div className="max-w-screen-2xl mx-auto px-8 py-20">
      <div className="text-center mb-12">
        <div className="text-blue-500 font-semibold tracking-[2px] text-sm mb-2">OPINIE KLIENTÓW</div>
        <h2 className="text-4xl md:text-5xl font-semibold tracking-tighter">Co mówią o nas nasi klienci</h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="dark-card rounded-3xl p-8 flex flex-col">
            <div className="flex mb-4 text-yellow-400">
              {"★★★★★".split('').map((s, i) => <span key={i}>{s}</span>)}
            </div>
            <blockquote className="text-lg leading-snug mb-6 flex-1">
              „{testimonial.quote}”
            </blockquote>
            <div>
              <div className="font-semibold">{testimonial.name}</div>
              <div className="text-sm text-zinc-400">
                {testimonial.role} • {testimonial.location}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <a 
          href="#kontakt" 
          onClick={(e) => {
            e.preventDefault();
            const el = document.getElementById('kontakt');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}
          className="inline-flex items-center gap-2 px-8 py-3 bg-white text-zinc-950 font-semibold rounded-3xl hover:bg-zinc-100 transition-colors"
        >
          Zostań naszym klientem
        </a>
      </div>
      </div>
    </section>
  );
}
